export default __webpack_public_path__ + "static/media/63.c12df186.jpeg";